/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Suppliers_Not_On_BcInputs */

const en_queue_suppliers_not_on_bc = /** @type {(inputs: Queue_Suppliers_Not_On_BcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppliers with open POs to register in Business Central`)
};

/**
* | output |
* | --- |
* | "Suppliers with open POs to register in Business Central" |
*
* @param {Queue_Suppliers_Not_On_BcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_suppliers_not_on_bc = /** @type {((inputs?: Queue_Suppliers_Not_On_BcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Suppliers_Not_On_BcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_suppliers_not_on_bc(inputs)
});